import { render, staticRenderFns } from "./emailConfig.vue?vue&type=template&id=18d617c4&scoped=true"
import script from "./emailConfig.vue?vue&type=script&lang=js"
export * from "./emailConfig.vue?vue&type=script&lang=js"
import style0 from "./emailConfig.vue?vue&type=style&index=0&id=18d617c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d617c4",
  null
  
)

export default component.exports